var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-lg-6" },
      [
        _c(
          "FormWrapper",
          [
            _c(
              "FormControl",
              [
                _c("FormLabel", [_vm._v(_vm._s(_vm.$t("watches.name")))]),
                _vm._v(" "),
                _c("UiInput", {
                  model: {
                    value: _vm.shift.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.shift, "name", $$v)
                    },
                    expression: "shift.name",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "FormControl",
              [
                _c(
                  "FormElement",
                  [
                    _c(
                      "BFormCheckbox",
                      {
                        staticClass: "ml-2",
                        attrs: {
                          name: "check-button",
                          switch: "",
                          "aria-label": _vm.$t("watches.active_shift"),
                        },
                        model: {
                          value: _vm.shift.active,
                          callback: function ($$v) {
                            _vm.$set(_vm.shift, "active", $$v)
                          },
                          expression: "shift.active",
                        },
                      },
                      [
                        _vm.shift.active
                          ? _c("strong", [
                              _vm._v(_vm._s(_vm.$t("watches.activated"))),
                            ])
                          : _c("span", [
                              _vm._v(_vm._s(_vm.$t("watches.activate"))),
                            ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "FormControl",
              [
                _c("FormLabel", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("watches.label_days")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "FormElement",
                  [
                    _c(
                      "BFormCheckboxGroup",
                      {
                        attrs: { stacked: "" },
                        model: {
                          value: _vm.shift.days,
                          callback: function ($$v) {
                            _vm.$set(_vm.shift, "days", $$v)
                          },
                          expression: "shift.days",
                        },
                      },
                      _vm._l(_vm.europeanWeek, function (day) {
                        return _c(
                          "BFormCheckbox",
                          { key: day, attrs: { value: day } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.dayName(day)) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.shift.days.length
                  ? _c("FormError", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("watches.error_days")) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "FormControl",
              [
                _c("FormLabel", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("watches.label_time")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("FormElement", [
                  _c("div", { staticClass: "d-flex flex-wrap" }, [
                    _c(
                      "div",
                      { staticClass: "flex-fill" },
                      [
                        _c("UiInput", {
                          staticStyle: { "margin-right": "-1px" },
                          attrs: { type: "time" },
                          model: {
                            value: _vm.shift.time_start,
                            callback: function ($$v) {
                              _vm.$set(_vm.shift, "time_start", $$v)
                            },
                            expression: "shift.time_start",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex-fill" },
                      [
                        _c("UiInput", {
                          staticStyle: { "margin-left": "-1px" },
                          attrs: { type: "time" },
                          model: {
                            value: _vm.shift.time_end,
                            callback: function ($$v) {
                              _vm.$set(_vm.shift, "time_end", $$v)
                            },
                            expression: "shift.time_end",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-mono ml-2",
                        style: {
                          color: "var(--colors-gray-500)",
                          lineHeight: "var(--input-height)",
                        },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.timeDifference) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "FormControl",
              [
                _c(
                  "BFormCheckbox",
                  {
                    model: {
                      value: _vm.shift.dates_active,
                      callback: function ($$v) {
                        _vm.$set(_vm.shift, "dates_active", $$v)
                      },
                      expression: "shift.dates_active",
                    },
                  },
                  [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("watches.active_dates"))),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.shift.dates_active
              ? _c(
                  "FormControl",
                  [
                    _c("FormLabel", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("watches.label_date")) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("FormElement", [
                      _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _c("UiInput", {
                            class: !_vm.validDates && "is-invalid",
                            staticStyle: { "margin-right": "-1px" },
                            attrs: { type: "date" },
                            model: {
                              value: _vm.shift.date_start,
                              callback: function ($$v) {
                                _vm.$set(_vm.shift, "date_start", $$v)
                              },
                              expression: "shift.date_start",
                            },
                          }),
                          _vm._v(" "),
                          _c("UiInput", {
                            class: !_vm.validDates && "is-invalid",
                            staticStyle: { "margin-left": "-1px" },
                            attrs: { type: "date" },
                            model: {
                              value: _vm.shift.date_end,
                              callback: function ($$v) {
                                _vm.$set(_vm.shift, "date_end", $$v)
                              },
                              expression: "shift.date_end",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    !_vm.validDates
                      ? _c("FormError", [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("watches.error_date")) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-lg-6" },
      [
        _c("ChannelSelectGroup", {
          attrs: { proLicences: _vm.proLicences },
          model: {
            value: _vm.shift.channels,
            callback: function ($$v) {
              _vm.$set(_vm.shift, "channels", $$v)
            },
            expression: "shift.channels",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }